/* eslint-disable func-style */
const RightPanel = () => import('@/components/RightPanel.vue');// 右滑详情页面
const TemplateManage = () => import('@/pages/SysMenu/TemplateManage');
const TemplateManageNew = () => import('@/pages/SysMenu/TemplateManageNew');
const TemplateManageEdit = () => import('@/pages/SysMenu/TemplateManageEdit');
const IncomingPaymentAccount = () => import('@/pages/SysMenu/IncomingPaymentAccount');
const AccountManage = () => import('@/pages/SysMenu/AccountManage');
const EditManagePage = () => import('@/pages/SysMenu/EditManagePage');
const ManageDetail = () => import('@/pages/SysMenu/ManageDetail');
const AccountManageEdit = () => import('@/pages/SysMenu/AccountManageEdit');
const AccountManageNew = () => import('@/pages/SysMenu/AccountManageNew');
const NewManagePage = () => import('@/pages/SysMenu/NewManagePage');
const ChargeTypeTemplate = () => import('@/pages/SysMenu/ChargeTypeTemplate');
const DepartmentManagement = () => import('@/pages/SysMenu/DepartmentManagement');
const TicketTemplate = () => import('@/pages/SysMenu/TicketTemplate');
const ProManageDepartment = () => import('@/pages/SysMenu/ProManageDepartment');
const CampusManage = () => import('@/pages/SysMenu/CampusManage');
const DepartmentManage = () => import('@/pages/SysMenu/DepartmentManage');
const ProfessionalManage = () => import('@/pages/SysMenu/ProfessionalManage');
const ProfessionalManageExcel = () => import('@/pages/SysMenu/ProfessionalManageExcel');
const MenuManagement = () => import('@/pages/SysMenu/MenuManagement');
const RoleManage = () => import('@/pages/SysMenu/RoleManage');
const RoleManageEdit = () => import('@/pages/SysMenu/RoleManageEdit');
const RoleManageNew = () => import('@/pages/SysMenu/RoleManageNew');
const DictionaryManage = () => import('@/pages/SysMenu/DictionaryManage');
const StudentStatusManagement = () => import('@/pages/SysMenu/StudentStatusManagement');
const ChargeAccountMaintenance = () => import('@/pages/SysMenu/ChargeAccountMaintenance');
const ParameterManage = () => import('@/pages/SysMenu/ParameterManage');
const BusinessManage = () => import('@/pages/SysMenu/BusinessManage');
const ElectronicInvoiceAccountMapping = () => import('@/pages/SysMenu/ElectronicInvoiceAccountMapping');
const ElectronicInvoiceAccountMappingExcel = () => import('@/pages/SysMenu/ElectronicInvoiceAccountMappingExcel');
const BelongBusinessManage = () => import('@/pages/SysMenu/BelongBusinessManage');
const OperatorLog = () => import('@/pages/SysMenu/OperatorLog');
const pageConfigManage = () => import('@/pages/SysMenu/pageConfigManage');
const pageConfigEdit = () => import('@/pages/SysMenu/pageConfigEdit');
const CollectInfoManage = () => import('@/pages/SysMenu/CollectInfoManage');
const AddCollectInfo = () => import('@/pages/SysMenu/AddCollectInfo');
const GraduateSchoolMaintain = () => import('@/pages/SysMenu/GraduateSchoolMaintain');
const ImportGrduateSchool = () => import('@/pages/SysMenu/ImportGrduateSchool');
const GradeMaintance = () => import('@/pages/SysMenu/GradeMaintance');
const ImportGradeMaintance = () => import('@/pages/SysMenu/ImportGradeMaintance');
const SettleAccountBank = () => import('@/pages/SysMenu/SettleAccountBank');

const serviceRouter = [
	{ path: '/SettleAccountBank', name: 'SettleAccountBank', component: SettleAccountBank },
	{ path: '/TemplateManage', name: 'TemplateManage', component: TemplateManage },
	{ path: '/GradeMaintance', name: 'GradeMaintance', component: GradeMaintance },
	{ path: '/ImportGradeMaintance', name: 'ImportGradeMaintance', component: ImportGradeMaintance },
	{ path: '/CollectInfoManage', name: 'CollectInfoManage', component: CollectInfoManage },
	{ path: '/AddCollectInfo', name: 'AddCollectInfo', component: AddCollectInfo },
	{ path: '/EditCollectInfo/:key_id', name: 'EditCollectInfo', component: AddCollectInfo },
	{ path: '/TemplateManageNew', name: 'TemplateManageNew', component: TemplateManageNew },
	{ path: '/TemplateManageEdit', name: 'TemplateManageEdit', component: TemplateManageEdit },
	{ path: '/IncomingPaymentAccount', name: 'IncomingPaymentAccount', component: IncomingPaymentAccount },
	{
		path: '/GraduateSchoolMaintain',
		name: 'GraduateSchoolMaintain',
		component: GraduateSchoolMaintain,
	},
	{
		path: '/ImportGrduateSchool',
		name: 'ImportGrduateSchool',
		component: ImportGrduateSchool,
	},
	{
		path: '/AccountManage',
		name: 'AccountManage',
		component: AccountManage,
		children: [
			{
				path: '/ManageRightPanel',
				name: 'ManageRightPanel',
				meta: { parent: '/AccountManage' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/ManageDetail/:subParams',
						name: 'ManageDetail',
						meta: { parent: '/AccountManage' },
						component: ManageDetail,
					},
				],
			},
		],
	},
	{ path: '/EditManagePage/:subParams', name: 'EditManagePage', component: EditManagePage },
	{ path: '/NewManagePage', name: 'NewManagePage', component: NewManagePage },
	{ path: '/ChargeTypeTemplate', name: 'ChargeTypeTemplate', component: ChargeTypeTemplate },
	{ path: '/DepartmentManagement', name: 'DepartmentManagement', component: DepartmentManagement },
	{ path: '/TicketTemplate', name: 'TicketTemplate', component: TicketTemplate },
	{
		path: '/CampusManage',
		name: 'ProManageDepartment',
		component: ProManageDepartment,
		children: [
			{
				path: '/', name: 'Campus', meta: { parent: '/CampusManage' }, component: CampusManage,
			},
			{
				path: '/DepartmentManage', name: 'DepartmentManage', meta: { parent: '/CampusManage' }, component: DepartmentManage,
			},
			{
				path: '/ProfessionalManage', name: 'ProfessionalManage', meta: { parent: '/CampusManage' }, component: ProfessionalManage,
			},
		],
	}, // 导表
	{ path: '/SysCurrencyGuideExcel', name: 'SysCurrencyGuideExcel', component: ProfessionalManageExcel },
	{ path: '/MenuManagement', name: 'MenuManagement', component: MenuManagement },
	{ path: '/MenuManageEdit', name: 'MenuManageEdit', component: AccountManageEdit },
	{ path: '/MenuManageNew', name: 'MenuManageNew', component: AccountManageNew },
	{ path: '/RoleManage', name: 'RoleManage', component: RoleManage },
	{ path: '/RoleManageEdit', name: 'RoleManageEdit', component: RoleManageEdit },
	{ path: '/RoleManageNew', name: 'RoleManageNew', component: RoleManageNew },
	{ path: '/DictionaryManage', name: 'DictionaryManage', component: DictionaryManage },
	{ path: '/StudentStatusManagement', name: 'StudentStatusManagement', component: StudentStatusManagement },
	{ path: '/ChargeAccountMaintenance', name: 'ChargeAccountMaintenance', component: ChargeAccountMaintenance },
	{ path: '/ParameterManage', name: 'ParameterManage', component: ParameterManage },
	{ path: '/BusinessManage', name: 'BusinessManage', component: BusinessManage },
	{ path: '/ElectronicInvoiceAccountMapping', name: 'ElectronicInvoiceAccountMapping', component: ElectronicInvoiceAccountMapping },
	{ path: '/ElectronicInvoiceAccountMappingExcel', name: 'ElectronicInvoiceAccountMappingExcel', component: ElectronicInvoiceAccountMappingExcel },
	{
		path: '/BelongBusinessManage',
		name: 'BelongBusinessManage',
		component: BelongBusinessManage,
	}, {
		path: '/OperatorLog',
		component: OperatorLog,
		name: 'OperatorLog',
	},
	{
		path: '/pageConfigManage',
		component: pageConfigManage,
		name: 'pageConfigManage',
	},
	{
		path: '/pageConfigEdit',
		component: pageConfigEdit,
		name: 'pageConfigEdit',
	},
];
export default serviceRouter;
